import type { ProductAddFormValues, ProductListQuery } from '../types'

/** Angular `product-list.component.ts` / layout `product_menu` + granular policies */
export const PRODUCT_POLICIES = {
  MENU: 'product_menu',
  LISTING: 'product_listing',
  ADD: 'product_add',
  EDIT: 'product_edit',
  DELETE: 'product_delete',
} as const

export const PRODUCT_LIST_SESSION_KEY = 'productlist_filter'

export const PRODUCT_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const

export const DESCRIPTION_MAX = 250

export const DEFAULT_PRODUCT_LIST_QUERY: ProductListQuery = {
  page: 1,
  perPage: 10,
  sortBy: 'asc',
  orderBy: 'name',
}

export const PRODUCT_ADD_INITIAL_VALUES: ProductAddFormValues = {
  name: '',
  description: '',
  long_description: '',
  allow_dynamic_access_fee: false,
  is_active: false,
}

export const DEFAULT_RISK_COLORS = [
  '#e74c3c',
  '#f39c12',
  '#e67e22',
  '#2ecc71',
  '#3498db',
  '#9b59b6',
  '#1abc9c',
  '#e91e63',
]

export const RISK_MATRIX_CELL_MENU_Z = 60
export const RISK_MATRIX_CELL_VIEWPORT_GAP = 8
